import {Injectable} from '@angular/core';
import {Http} from '@angular/http';
import {constant} from 'app/app.constants';
import {IRiderAlert} from 'app/core/models/rider-alert.model';
import {ParentService} from 'app/pages/A2-utils/ParentClass/ParentService';
import {Observable} from 'rxjs/Observable';

export enum EnumTypeAlertRider {
  Dispatch = 1,
  Billing = 2,
  Reservation = 3
}
@Injectable()
export class RiderAlertService extends ParentService {

  constructor(private httpClient: Http) {
    super();
  }

  getAlertsByRiderId(riderId: number, isActive: boolean) {
    if (!isActive) { isActive = false; }
    return this.httpClient.get(`${constant.RIDER_ALERTS}/ByRider/${riderId}/${isActive}`, this.getHeader())
      .map(response => response.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  getAlertTypes() {
    return this.httpClient.get(constant.ALERT_TYPES, this.getHeader())
      .map(response => response.json());
  }

  saveAlert(alert: IRiderAlert) {
    return this.httpClient.post(constant.RIDER_ALERTS, JSON.stringify(alert), this.headerPost())
      .map(response => response.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  updateAlert(alert: IRiderAlert) {
    return this.httpClient.put(constant.RIDER_ALERTS, JSON.stringify(alert), this.headerPost())
      .map(response => response.json())
      .catch((error: any) => Observable.throw(error.json()));
  }

  deleteAlert(id: number) {
    return this.httpClient.delete(`${constant.RIDER_ALERTS}/${id}`, this.headerPost())
      .map(response => response.json())
      .catch((error: any) => Observable.throw(error.json()));
  }
  getAlertRiderByTypes(riderId: number, type: EnumTypeAlertRider): Observable<string[]> {
    return this.httpClient.get(`${constant.URL_RIDER_ALERTS_BY_TYPE}/${riderId}/${type}`, this.getHeader())
      .map(response => response.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/rider/services/rider-alert.service.ts